export default "__VITE_ASSET__6c1c199a__"